import React from "react";
import styled from "@emotion/styled";
import RadioButton from "@components/button/RadioButton";
import { useFormContext } from "react-hook-form";

const Container = styled.div({
  display: "flex",
  gap: "3rem",
});

type Option = {
  value: string | boolean;
  label: string;
};

type Props = {
  options: Option[];
  name: string;
};
const RadioGroup = ({ options, name }: Props) => {
  const { setValue, watch } = useFormContext();

  const handleClick = (value: string | boolean) => {
    setValue(name, value);
  };
  return (
    <Container>
      {options.map((item, index) => (
        <RadioButton
          key={index}
          label={item.label}
          onClick={() => handleClick(item.value)}
          active={watch(name) === item.value}
        />
      ))}
    </Container>
  );
};

export default RadioGroup;
